// This mixin applies color filters to product list
import ColorFilter from "../components/ColorFilter.vue";

export default {
  components: {
    ColorFilter
  },

  data() {
    return {
      colorFilters:
        window._PR && window._PR.colorFilters ? window._PR.colorFilters : [],
      allColors: true,
      filterProducts: false
    };
  },

  computed: {
    selectedColorFilters() {
      let colorFilters = [];
      if (!this.allColors) {
        colorFilters = this.colorFilters
          .filter(filter => filter.checked)
          .map(filter => filter.code);
      }

      if (colorFilters.length === 0) {
        this.allColors = true;
      }
      return colorFilters;
    }
  },

  mounted() {
    let vm = this;

    vm.$on("color-filter-updated", affectedFilter => {
      if (affectedFilter !== null) {
        vm.allColors = false;

        const dataObj = {
          id: affectedFilter.id,
          type: "color_category",
          label: affectedFilter.name,
          description: "Color Category",
          code: affectedFilter.code,
          checked: true,
          search: affectedFilter.name
        };

        if (affectedFilter.checked) {
          vm.selectedTags.push(dataObj);
        } else {
          // necessary to remove a specific color tag
          vm.selectedTags.splice(vm.selectedTags.findIndex(i => { return i.id === affectedFilter.id; }), 1);
        }
      }
    });

    vm.$on("all-color-filters-checked", () => {
      const colors = vm.selectedTags.filter(item => item.type === "color_category");

      // necessary to remove all color tags (if they exist).
      for (const color of colors) {
        vm.selectedTags.splice(vm.selectedTags.findIndex(i => { return i.id === color.id; }), 1);
      }
    });
  },

  watch: {
    selectedTags(tag) {
      let vm = this;

      if (tag.type === "color_category" && !vm.getColorFilters()) {
        vm.allColors = false;
        vm.updateFilter(tag);
      }

      if (tag.type === "color_category") {
        vm.allColors = false;
      }

      vm.repaintControls();
      vm.resetLoading();
    }
  },

  methods: {
    repaintControls() {
      const colors = this.selectedTags.filter(item => item.type === "color_category");
      const hashtags = this.selectedTags.filter(item => item.type === "hashtag");
      const bookmarked = this.selectedTags.filter(item => item.type === "bookmarked");
      const uploads = this.selectedTags.filter(item => item.type === "owned");

      this.owned = uploads.length !== 0;
      this.bookmarked = bookmarked.length !== 0;

      this.colorFilters.map(filter => {
        filter.checked = colors.some(color => {
          return filter.id === color.id;
        });
      });
    },

    checkAllFilter() {
      this.allColors = true;
      this.colorFilters.map(filter => {
        filter.checked = false;
      });
      this.$forceUpdate();
      this.$emit("all-color-filters-checked");
      this.resetLoading();
    },

    getColorFilters() {
      return this.selectedColorFilters;
    },

    updateFilter(affectedFilter) {
      const filterIndex = this.colorFilters.findIndex(
        filter => filter.id === affectedFilter.id
      );

      this.colorFilters[filterIndex].checked = !affectedFilter.checked;

      this.allColors = this.colorFilters.every(filter => !filter.checked);

      this.products = [];

      // if this is on gallery page then also update the tab
      if (this.currentTab) {
        this.changeTab("color");
      }
      this.$forceUpdate();

      this.$emit("color-filter-updated", affectedFilter);
    }
  }
};
